import { getStringArrayDay, MONTH_ARRAY, YEAR_ARRAY } from 'constants/reservation';
import React, { createContext, useContext, useReducer } from 'react';
import ActionTypes from './actions';
import reducerBooking from './reducer';

export enum TypeForDialog {
  PRECAUTION_FOR_BODY = 'PRECAUTION_FOR_BODY',
  ADULT_STUDENT_USING_SERVICE = 'ADULT_STUDENT_USING_SERVICE',
  PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
  RECEIVED_APPOINTMENT_DATE = 'RECEIVED_APPOINTMENT_DATE',
  PRECAUTION_BEFORE_APPLICATION = 'PRECAUTION_BEFORE_APPLICATION',
}

export enum StatusBooking {
  AVAILABLE_BOOKING = 'AVAILABLE_BOOKING',
  CALL_BEFORE_BOOKING = 'CALL_BEFORE_BOOKING',
  CAN_NOT_BOOKING = 'CAN_NOT_BOOKING',
}

export type THandleChangeSearch = Pick<InitialStateType,
'chosenDesiredService' |
'chosenDesiredCare' |
'chosenCourse' |
'chosenArea' |
'chosenStore'|
'chosenDesiredServiceName'|
'chosenDesiredCareName'|
'chosenCourseName'|
'chosenAreaName'|
'chosenStoreName'|
'chosenCourseAcceptRequestReservation'
>
export type THandleChangeInfoCustomer = Pick<InitialStateType,
'customerFirstName'|
'customerLastName'|
'customerFirstNameNameInFurigawa'|
'customerLastNameNameInFurigawa'|
'customerBirthdayYear'|
'customerBirthdayMonth'|
'customerBirthdayDay'|
'phoneNumber1'|
'phoneNumber2'|
'phoneNumber3'|
'emailAddress'|
'consultationOrRequest'|
'isEmailNewsLetter'|
'desiredMonth1'|
'desiredDay1'|
'desiredHour1'|
'desiredMonth2'|
'desiredDay2'|
'desiredHour2'|
'desiredMonth3'|
'desiredDay3'|
'desiredHour3'
>

export type THandleChangeInfoBooking = Pick<InitialStateType,
'customerNumberBooking' |
'contractCourseNameBooking'|
'orgNameBooking'|
'birthDateBooking'|
'emailBooking' |
'customerTypeBooking' |
'reservationIdBooking' |
'companyCodeBooking' |
'reservationTypeBooking' |
'transactionIdBooking'
>
export interface IHandleChangeProps {
  name: string,
  value: InitialStateType[keyof InitialStateType]
}
export interface ISelectOption {
  id: string,
  text: string,
}

export interface IDefaultValueSearch{
  chosenDesiredService: string,
  chosenDesiredCare: string,
  chosenCourse: string,
  chosenArea: string,
  chosenStore: string,
}

export type InitialStateType = {
  companyCode: string,
   // Search Booking
  chosenDesiredService: string;
  chosenDesiredCare: string;
  chosenCourse: string;
  chosenArea: string;
  chosenStore: string;
  chosenDesiredServiceName?: string;
  chosenDesiredCareName?: string;
  chosenCourseName?: string;
  chosenAreaName?: string;
  chosenStoreName?: string;
  // リクエスト予約で受け付けるコース判定（true: 仮予約 / false: 即時予約）
  chosenCourseAcceptRequestReservation?: boolean;
  // Desired Time Booking
  desiredTime: string;
  status: keyof typeof StatusBooking,
  // Info Customer
  customerFirstName: string;
  customerLastName: string;
  customerFirstNameNameInFurigawa: string;
  customerLastNameNameInFurigawa: string;
  customerBirthdayYear: string;
  customerBirthdayMonth: string;
  customerBirthdayDay: string;
  phoneNumber1: string;
  phoneNumber2: string;
  phoneNumber3: string;
  emailAddress: string;
  consultationOrRequest: string;
  isEmailNewsLetter: string;
  desiredMonth1: string;
  desiredDay1: string;
  desiredHour1: string;
  desiredMonth2: string;
  desiredDay2: string;
  desiredHour2: string;
  desiredMonth3: string;
  desiredDay3: string;
  desiredHour3: string;
  // Info Booking
  customerNumberBooking:string,
  contractCourseNameBooking:string,
  orgNameBooking:string,
  birthDateBooking:string,
  emailBooking:string,
  customerTypeBooking:string,
  reservationIdBooking:string,
  transactionIdBooking:string,
  companyCodeBooking: string,
  reservationTypeBooking: string,
  // Dialog
  isDialogOpen: boolean;
  typeDialog: keyof typeof TypeForDialog;
  // Functions
  handleChangeSearch: (search: THandleChangeSearch) => void;
  handleChangeInfoCustomer: (customer: THandleChangeInfoCustomer) => void;
  handleChangeInfoBooking: (booking: THandleChangeInfoBooking) => void;
  handleChange: ({ name, value }: IHandleChangeProps) => void;

  handleDisplayDialog: ({ typeDialog }: {typeDialog: InitialStateType['typeDialog']}) => void;
  handleHideDialog: () => void;
  handleResetContext: () => void;
}


const initialStateBooking: InitialStateType = {
  companyCode: '',
  // Search Booking
  chosenDesiredService: '',
  chosenDesiredCare: '',
  chosenCourse: '',
  chosenArea: '',
  chosenStore: '',
  chosenDesiredServiceName: '',
  chosenDesiredCareName: '',
  chosenCourseName: '',
  chosenAreaName: '',
  chosenStoreName: '',
  chosenCourseAcceptRequestReservation: false,
  // Desired Time Booking
  desiredTime: '',
  status: StatusBooking.CAN_NOT_BOOKING,
  // Info Customer
  customerFirstName: '',
  customerLastName: '',
  customerFirstNameNameInFurigawa: '',
  customerLastNameNameInFurigawa: '',
  customerBirthdayYear: '2000',
  customerBirthdayMonth: MONTH_ARRAY[0],
  customerBirthdayDay: getStringArrayDay(MONTH_ARRAY[0], YEAR_ARRAY[0])[0],
  phoneNumber1: '',
  phoneNumber2: '',
  phoneNumber3: '',
  emailAddress: '',
  consultationOrRequest: '',
  isEmailNewsLetter: 'true',
  desiredMonth1: '',
  desiredDay1: '',
  desiredHour1: '',
  desiredMonth2: '',
  desiredDay2: '',
  desiredHour2: '',
  desiredMonth3: '',
  desiredDay3: '',
  desiredHour3: '',
  // Info Booking
  customerNumberBooking: '',
  contractCourseNameBooking: '',
  orgNameBooking: '',
  birthDateBooking: '',
  emailBooking: '',
  customerTypeBooking: '',
  reservationIdBooking: '',
  transactionIdBooking: '',
  companyCodeBooking: '',
  reservationTypeBooking: '',
  // Dialog
  isDialogOpen: false,
  typeDialog: TypeForDialog.ADULT_STUDENT_USING_SERVICE,
  // Functions
  handleChangeSearch: () => null,
  handleChangeInfoCustomer: () => null,
  handleChangeInfoBooking: () => null,
  handleDisplayDialog: () => null,
  handleHideDialog: () => null,
  handleChange: () => null,
  handleResetContext: () => null,
};

const ReservationBookingOnlineContext = createContext<InitialStateType>(initialStateBooking);

const ReservationBookingOnlineContextProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducerBooking, initialStateBooking);

  // HandleChange for Select, Input
  const handleChangeSearch = (payload: THandleChangeSearch) => {
    dispatch({
      type: ActionTypes.HANDLE_CHANGE_SEARCH,
      payload,
    });
  };

  const handleChangeInfoCustomer = (payload: THandleChangeInfoCustomer) => {
    dispatch({
      type: ActionTypes.HANDLE_CHANGE_INFO_CUSTOMER,
      payload,
    });
  };

  const handleChangeInfoBooking = (payload: THandleChangeInfoBooking) => {
    dispatch({
      type: ActionTypes.HANDLE_CHANGE_INFO_BOOKING,
      payload,
    });
  };

  const handleChange = ({ name, value }: IHandleChangeProps) => {
    dispatch({
      type: ActionTypes.HANDLE_CHANGE,
      payload: {
        name,
        value,
      },
    });
  };

  const handleResetContext = () => {
    dispatch({
      type: ActionTypes.HANDLE_RESET_CONTEXT,
      payload: initialStateBooking,
    });
  };

  // Handle Dialog
  const handleDisplayDialog = ({ typeDialog }: {typeDialog: InitialStateType['typeDialog']}) => {
    dispatch({
      type: ActionTypes.DISPLAY_DIALOG,
      payload: {
        typeDialog,
      },
    });
  };
  const handleHideDialog = () => {
    dispatch({
      type: ActionTypes.HIDE_DIALOG,
    });
  };

  return (
    <ReservationBookingOnlineContext.Provider value={{
      ...state, handleChange, handleChangeSearch, handleChangeInfoCustomer, handleChangeInfoBooking, handleDisplayDialog, handleHideDialog, handleResetContext,
    }}
    >
      {children}
    </ReservationBookingOnlineContext.Provider>
  );
};

const useReservationBookingOnlineContext = () => {
  const context = useContext(ReservationBookingOnlineContext);
  if (!context) {
    throw new Error('That no context');
  }
  return context;
};

export { ReservationBookingOnlineContextProvider, useReservationBookingOnlineContext };
